import createReducer from 'lib/createReducer';
import { OPEN_NOTE_EDITOR, RESET_ANNOTATION } from './index';

export const SAVE_DEBOUNCE_NOTETEXT = 'SAVE_DEBOUNCE_NOTETEXT';


const initialState = {
  isNoteEditorOpen: false,
  autoSaveNoteText: '',
};

const actionHandlers = {
  [OPEN_NOTE_EDITOR]: (state, action) => {
    return { isNoteEditorOpen: !state.isNoteEditorOpen };
  },

  [RESET_ANNOTATION]: (state, action) => {
    return initialState;
  },

  [SAVE_DEBOUNCE_NOTETEXT]: (state, action) => {
    return { ...state, autoSaveNoteText: action.data };
  }
};


export default createReducer(initialState, actionHandlers);
